const NO_JS_CLASSNAME = 'no-js';

export default NO_JS_CLASSNAME;
